import getters from './getters';
import actions from './actions';
import mutations from './mutations';
var state = function state() {
  return {
    filterBy: null,
    sortBy: 'popular',
    orderBy: null,
    previousPage: 1,
    nextPage: 1
  };
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};